module.exports = __webpack_public_path__ + "static/gm-23-f6b15a50e70b65ec531d45573044c610.jpg";